import type { ManifestRouteDefinition } from '@/core/manifest/types'

export const roleRouteRoot: ManifestRouteDefinition = {
  key: 'role',
  path: '/roles',
  apiCalls: [
    { url: '/tenants/rbac/roles', method: 'GET' },
    { url: '/tenants/rbac/modules', method: 'GET' },
    { url: '/tenants/rbac/modules-features', method: 'GET' },
    { url: '/tenants/rbac/permissions', method: 'GET' },
    { url: '/tenants/rbac/access/bulk', method: 'POST' },
    { url: '/tenants/rbac/roles/:roleId/access-structure', method: 'GET' },
    { url: '/tenants/rbac/roles/:roleId/toggle-active', method: 'PATCH' },
  ],
  lazyComponent: () =>
    import('@/features/role/pages/RoleLayout/RoleLayout').then((m) => ({
      default: m.default,
    })),
  indexRedirect: 'active',
  children: [
    {
      key: 'role_active',
      path: 'active',
      apiCalls: [
        { url: '/tenants/rbac/roles?is_active=true', method: 'GET' },
        { url: '/tenants/rbac/roles/:roleId/toggle-active', method: 'PATCH' },
      ],
      lazyComponent: () =>
        import('@/features/role/pages/RoleActivePage/RoleActivePage').then((m) => ({
          default: m.default,
        })),
    },
    {
      key: 'role_deleted',
      path: 'deleted',
      apiCalls: [
        { url: '/tenants/rbac/roles?is_active=false', method: 'GET' },
        { url: '/tenants/rbac/roles/:roleId/toggle-active', method: 'PATCH' },
      ],
      lazyComponent: () =>
        import('@/features/role/pages/RoleDeletedPage/RoleDeletedPage').then((m) => ({
          default: m.default,
        })),
    },
    {
      key: 'role_create',
      path: 'create',
      apiCalls: [
        { url: '/tenants/rbac/modules', method: 'GET' },
        { url: '/tenants/rbac/modules-features', method: 'GET' },
        { url: '/tenants/rbac/permissions', method: 'GET' },
        { url: '/tenants/rbac/access/bulk', method: 'POST' },
      ],
      lazyComponent: () =>
        import('@/features/role/pages/RoleCreatePage/RoleCreatePage').then((m) => ({
          default: m.default,
        })),
    },
    {
      key: 'role_edit',
      path: ':roleId/edit',
      apiCalls: [
        { url: '/tenants/rbac/modules', method: 'GET' },
        { url: '/tenants/rbac/modules-features', method: 'GET' },
        { url: '/tenants/rbac/permissions', method: 'GET' },
        { url: '/tenants/rbac/roles/:roleId/access-structure', method: 'GET' },
        { url: '/tenants/rbac/access/bulk', method: 'POST' },
      ],
      lazyComponent: () =>
        import('@/features/role/pages/RoleEditPage/RoleEditPage').then((m) => ({
          default: m.default,
        })),
    },
  ],
}
